import { NavigationItem } from './navigation-item';

/**
 * Model definition for navigation
 */
export interface Navigation {
  __contentType: 'navigation';
  id: string;
  name: string;
  slug: string;
  visible?: boolean;
  items?: NavigationItem[];
}

export function isNavigation(obj: { __contentType?: string }): obj is Navigation {
  return obj.__contentType === 'navigation';
}
